import { createContext } from "react";
const RoomFacilityContext = createContext({});
export default RoomFacilityContext;
